<div class="sme-support-container">

    <!-- Banner Section -->
    <section class="sme-banner">
        <div class="container">

            <div class="banner-top">
                <div class="text-content">
                    <h1>Affordable HR Solutions for SMEs: Streamline Your Operations With Ease</h1>
                    <button class="btn-consultation" (click)="navigationFromCTA()">Book Consultation</button>
                </div>

                <div class="image-content">
                    <div class="image-wrapper">
                        <img src="../../../../../assets/images/sme-support/banner.jpg" alt="Professional HR Consultant">
                    </div>
                </div>
            </div>

            <div class="banner-bottom">
                <div class="description-text">
                    <p>
                        Handling HR in-house can quickly become overwhelming for many small and medium-sized businesses.
                        The cost of hiring HR staff, ensuring compliance, and managing payroll can take a huge toll on
                        both your budget and your focus.
                    </p>
                    <p>
                        At Worknigeria, we make it easier. Our HR support services are designed specifically for SMEs,
                        allowing you to outsource all HR functions—from staff management to compliance—so you can
                        keep your business running smoothly without the heavy expenses and administrative hassle.
                    </p>
                </div>

                <div class="iso-badge">
                    <img src="../../../../../assets/images/iso-certification.png" alt="ISO 9001:2015 Certified">
                </div>
            </div>

        </div>
    </section>

    <!-- What We Offer Section -->
    <section class="what-we-offer-section">
        <div class="container">

            <h2 class="section-title">What We Offer</h2>

            <div class="offer-grid">

                <!-- Item 1 -->
                <div class="offer-item">
                    <div class="icon-wrapper">
                        <img src="../../../../../assets/images/sme-support/sme-s2-i1.png" alt="Employee Management">
                    </div>
                    <h3>Employee Management:</h3>
                    <p>
                        Comprehensive support in handling employee interactions,
                        performance management, and day-to-day HR activities.
                    </p>
                </div>

                <!-- Item 2 -->
                <div class="offer-item">
                    <div class="icon-wrapper">
                        <img src="../../../../../assets/images/sme-support/sme-s2-i2.png" alt="Documentation Services">
                    </div>
                    <h3>Documentation Services:</h3>
                    <p>
                        Professional compilation and maintenance of employment records,
                        contracts, and other relevant documents.
                    </p>
                </div>

                <!-- Item 3 -->
                <div class="offer-item">
                    <div class="icon-wrapper">
                        <img src="../../../../../assets/images/sme-support/sme-s2-i3.png"
                            alt="Registration & Compliance">
                    </div>
                    <h3>Registration & Compliance:</h3>
                    <p>
                        Assistance with employee registrations, statutory payments,
                        and regulatory compliance.
                    </p>
                </div>

                <!-- Item 4 -->
                <div class="offer-item">
                    <div class="icon-wrapper">
                        <img src="../../../../../assets/images/sme-support/sme-s2-i4.png" alt="HR Advisory">
                    </div>
                    <h3>HR Advisory and<br>Process Management:</h3>
                    <p>
                        We take over your HR processes after you've covered payments,
                        ensuring efficient and correct execution.
                    </p>
                </div>

                <!-- Item 5 -->
                <div class="offer-item">
                    <div class="icon-wrapper">
                        <img src="../../../../../assets/images/sme-support/sme-s2-i5.png"
                            alt="Human Capacity Development">
                    </div>
                    <h3>Human Capacity<br>Development:</h3>
                    <p>
                        We offer various skills development, coaching, and mentorship programs
                        to enhance your team's technical, leadership, and research skills.
                    </p>
                </div>

            </div>
        </div>
    </section>

    <!-- How It Works Section -->
    <section class="how-it-works-section">
        <div class="container">

            <!-- Left: Image -->
            <div class="image-column">
                <div class="image-wrapper">
                    <img src="../../../../../assets/images/sme-support/sme-s3-p1.png"
                        alt="Smiling professional woman at desk">
                </div>
            </div>

            <!-- Right: Content -->
            <div class="content-column">
                <h2 class="section-title">How It Works</h2>

                <div class="steps-list">

                    <!-- Step 1 -->
                    <div class="step-item">
                        <div class="icon-box yellow">
                            <img src="../../../../../assets/images/sme-support/sme-s3-i1.png" alt="Consultation">
                        </div>
                        <div class="step-text">
                            <h3>Initial Consultation:</h3>
                            <p>
                                You approach Worknigeria for HR support. We examine your needs
                                and identify the services required.
                            </p>
                        </div>
                    </div>

                    <!-- Step 2 -->
                    <div class="step-item">
                        <div class="icon-box orange">
                            <img src="../../../../../assets/images/sme-support/sme-s3-i2.png" alt="Agreement">
                        </div>
                        <div class="step-text">
                            <h3>Agreement and Customization:</h3>
                            <p>
                                We sign an agreement defining the exact support we’ll provide
                                and create clear limits and expectations.
                            </p>
                        </div>
                    </div>

                    <!-- Step 3 -->
                    <div class="step-item">
                        <div class="icon-box teal">
                            <img src="../../../../../assets/images/sme-support/sme-s3-i3.png" alt="Management">
                        </div>
                        <div class="step-text">
                            <h3>Outsourced HR Management:</h3>
                            <p>
                                Our team operates as your HR department, handling operations
                                remotely or through on-site visits as needed.
                            </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </section>

    <!-- Benefits Section -->
    <section class="benefits-section">
        <div class="container">

            <!-- Title Column -->
            <div class="title-column">
                <div class="section-title-wrapper">
                    <span class="quote-icon">❝</span>
                    <h2 class="section-title">
                        Benefits of Our<br>SME HR Support
                    </h2>
                </div>
            </div>

            <!-- Benefits Staggered Grid -->
            <div class="benefits-columns-wrapper">

                <!-- Left Column (Starts Lower, Green Glow) -->
                <div class="cards-column left-column">

                    <div class="benefit-card green-glow">
                        <h3>Cost Efficiency:</h3>
                        <p>
                            Save on pay bills, pensions, administrative fees, and work gear.
                        </p>
                    </div>

                    <div class="benefit-card green-glow">
                        <h3>Focus on Core Competencies:</h3>
                        <p>
                            Concentrate on your business’s strategic growth while we manage the HR complications.
                        </p>
                    </div>

                </div>

                <!-- Right Column (Starts Higher, White/Gray Shadow) -->
                <div class="cards-column right-column">

                    <div class="benefit-card green-glow">
                        <h3>Expert HR Guidance:</h3>
                        <p>
                            Benefit from our team’s knowledge and insights to optimize HR procedures.
                        </p>
                    </div>

                    <div class="benefit-card green-glow">
                        <h3>Enhanced Performance Management:</h3>
                        <p>
                            We link HR strategy with company objectives to drive performance and growth.
                        </p>
                    </div>

                    <div class="benefit-card green-glow">
                        <h3>Mentorship and Coaching:</h3>
                        <p>
                            Pairing SMEs with experienced industry leaders for guidance.
                        </p>
                    </div>

                </div>

            </div>

        </div>
    </section>

    <!-- Who Can Benefit & Contact Form Section -->
    <section class="who-can-benefit-section" id='contact-form'>
        <div class="container">

            <!-- Left: Text Content -->
            <div class="text-column">
                <h2 class="section-title">Who Can Benefit<br>from Our Services?</h2>
                <p class="subtitle">Our HR support is great for:</p>

                <ul class="benefit-list">

                    <li class="benefit-item">
                        <div class="check-icon">
                            <!-- Simple SVG Checkmark -->
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <p>Startups striving to develop efficient HR processes.</p>
                    </li>

                    <li class="benefit-item">
                        <div class="check-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <p>SMEs that cannot afford or do not want the responsibility of a full-time HR department.</p>
                    </li>

                    <li class="benefit-item">
                        <div class="check-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <p>Businesses seeking expert HR services to achieve growth and compliance.</p>
                    </li>

                </ul>
            </div>

            <!-- Right: Contact Form -->
            <div class="form-column">
                <div class="consultation-form-card">

                    <!-- Form Header Image/Text -->
                    <div class="form-header">
                        <div class="header-content">
                            <!-- Replace with your specific illustration -->
                            <img src="../../../../../assets/images/sme-support/sme-s5-form-p1.png" alt="Consultation">
                            <h3>GET A FREE<br>CONSULTATION</h3>
                        </div>
                    </div>

                    <form [formGroup]="consultationForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <input type="text" placeholder="Name*" required formControlName="name">
                        </div>

                        <div class="form-group">
                            <input type="email" placeholder="Email*" required formControlName="email">
                        </div>

                        <div class="form-group">
                            <input type="tel" placeholder="Phone Number*" required formControlName="phone">
                        </div>

                        <button type="submit" class="btn-submit">SEND</button>
                    </form>

                </div>
            </div>

        </div>
    </section>

    <!-- Testimonials Section -->
    <section class="testimonials-section">
        <div class="container">

            <!-- Section Header -->
            <div class="section-header">
                <h2 class="section-title">Testimonials</h2>
                <p class="subtitle">See how our HR support has helped SMEs thrive—real stories from businesses like
                    yours.</p>
            </div>

            <!-- Testimonial Cards Grid -->
            <div class="testimonials-grid">

                <!-- Card 1 -->
                <div class="testimonial-card">
                    <div class="avatar-circle green">KE</div>
                    <p class="quote">
                        “I am happy to be part of this training. The facilitator did a great job and I learnt so much
                        from him. A big thank you to Worknigeria for this opportunity”
                    </p>
                    <div class="stars">
                        ★★★★☆
                    </div>
                    <p class="author">- Kelechi Eke (The Tonic Technologies)</p>
                </div>

                <!-- Card 2 -->
                <div class="testimonial-card">
                    <div class="avatar-circle orange">OD</div>
                    <p class="quote">
                        “WorkNigeria lives up to their name in the HR industry”
                    </p>
                    <div class="stars">
                        ★★★★☆
                    </div>
                    <p class="author">- Obirai Dumebi</p>
                </div>

                <!-- Card 3 -->
                <div class="testimonial-card">
                    <div class="avatar-circle lime">AO</div>
                    <p class="quote">
                        “The engagement sessions with the pool of professional facilitators were exceptional. The
                        sessions were interactive and learner-centered.”
                    </p>
                    <div class="stars">
                        ★★★★☆
                    </div>
                    <p class="author">- Adedayo Ogunmowo (PWAN Group)</p>
                </div>

            </div>

        </div>
    </section>

    <!-- CTA Banner Section -->
    <section class="cta-banner-section">
        <div class="container">

            <!-- Left: Text Content -->
            <div class="text-content">
                <h2>Take your business to the next level today with Worknigeria</h2>
                <p>
                    Outsourcing your HR function to Worknigeria is a
                    strategic choice to save expenses, improve
                    productivity, and focus on scaling your business. Let
                    us assist you address the critical human-related
                    concerns that drive SME growth.
                </p>
                <button class="btn-consultation" (click)="navigationFromCTA()">Get Free Consultation</button>
            </div>

            <!-- Right: Image -->
            <div class="image-content">
                <div class="image-wrapper">
                    <img src="../../../../../assets/images/sme-support/sme-s7-p1.png"
                        alt="Business owners discussing in shop">
                </div>
            </div>

        </div>
    </section>

</div>